import {useEffect} from "react"
import {Link, useHistory} from "react-router-dom"
import {User, MessageSquare, ChevronRight, AlertCircle, RefreshCw} from "react-feather"
import {
    Row,
    Col,
    Spinner
} from "reactstrap"
import {getRecommendedRdsAtBrandsDashboard} from "@src/redux/actions/brandsDashboard"
import {useSelector, useDispatch} from "react-redux"
import BlankProfile from "@src/assets/images/avatars/avatar-blank.png"

export const MAX_RECOMMENDED_RDS = 8

export const getVisibleRecommendedRds = (recommendations, limit = MAX_RECOMMENDED_RDS) => {
    const unique = new Map()
    const source = recommendations || []

    source.forEach(rd => {
        if (rd?.id && !unique.has(rd.id)) {
            unique.set(rd.id, rd)
        }
    })

    return Array.from(unique.values()).slice(0, limit)
}

const RecommendedRDs = () => {
    const history = useHistory()

    const dispatch = useDispatch()

    const {
        brandRecRDsLoading,
        brandRecRDsFullFill,
        brandRecRDsError
    } = useSelector(store => store.brandsDashboardSlice || {})

    useEffect(() => {
        dispatch(getRecommendedRdsAtBrandsDashboard(""))
    }, [dispatch])

    const handleRedirectMessage = (user) => {
        localStorage.setItem('selectedChatRd', JSON.stringify(user))
        history.push(`/brands/apps/chat/chatBrands/${user.id}`)
    }

    const recommendations = getVisibleRecommendedRds(brandRecRDsFullFill?.data)

    return (
        <div className="figma-split-card" id="brand-recommended-rds-card">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="figma-section-label mb-0">
                    RECOMMENDED DIETITIANS
                </div>
                <Link to="/dashboard/brands/nutritions" className="figma-explore-more-link">
                    <span className="explore-more-text">Explore All RDs</span>
                    <ChevronRight size={14} className="explore-more-arrow ml-25" />
                </Link>
            </div>

            {brandRecRDsLoading ? (
                <div className="d-flex justify-content-center align-items-center py-4" style={{minHeight: '200px'}}>
                    <Spinner color='primary'/>
                </div>
            ) : brandRecRDsError ? (
                <div className="text-center py-3">
                    <AlertCircle size={22} className="text-danger mb-50" />
                    <p className="text-danger font-weight-bold mb-75 font-small-3">Unable to load recommended dietitians.</p>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                        onClick={() => dispatch(getRecommendedRdsAtBrandsDashboard(""))}
                    >
                        <RefreshCw size={12} className="mr-50" />
                        Retry
                    </button>
                </div>
            ) : recommendations.length === 0 ? (
                <div className="text-center py-3">
                    <p className="text-muted mb-0 font-small-3">No recommendations are available yet.</p>
                </div>
            ) : (
                <Row className="match-height">
                    {recommendations.map((rd) => {
                        const industryVal = rd?.industry?.[0]?.value
                        const specialityVal = rd?.speciality?.[0]?.value
                        let specialtyLabel = "Registered Dietitian"
                        if (industryVal && specialityVal) {
                            specialtyLabel = `${industryVal} • ${specialityVal}`
                        } else if (specialityVal) {
                            specialtyLabel = specialityVal
                        } else if (industryVal) {
                            specialtyLabel = industryVal
                        }

                        return (
                            <Col xs="12" sm="6" md="6" lg="3" key={rd.id} className="mb-2">
                                <div className="figma-rd-card h-100 d-flex flex-column align-items-center text-center">
                                    <div className="figma-rd-avatar-wrapper mb-1">
                                        <img
                                            src={rd?.profile_img || BlankProfile}
                                            alt={rd?.name || "Dietitian"}
                                            className="figma-rd-avatar-img"
                                        />
                                    </div>
                                    <h4 className="figma-rd-name mb-50" title={rd?.name}>
                                        {rd?.name || "N/A"}
                                    </h4>
                                    <div className="figma-rd-specialty-badge" title={specialtyLabel}>
                                        <span>{specialtyLabel}</span>
                                    </div>
                                    <div className="figma-rd-card-actions w-100 mt-auto">
                                        <Link
                                            to={`/dashboard/brands/nutritions/${rd.id}`}
                                            className="btn-rd-action-primary"
                                            id={`ProfileTooltip_${rd?.id}`}
                                        >
                                            <User size={14} className="mr-50 flex-shrink-0" />
                                            <span>View Profile</span>
                                        </Link>
                                        <button
                                            type="button"
                                            className="btn-rd-action-secondary"
                                            onClick={() => handleRedirectMessage(rd)}
                                            id={`MsgTooltip_${rd?.id}`}
                                        >
                                            <MessageSquare size={14} className="mr-50 flex-shrink-0" />
                                            <span>Message</span>
                                        </button>
                                    </div>
                                </div>
                            </Col>
                        )
                    })}
                </Row>
            )}
        </div>
    )
}

export default RecommendedRDs
